import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio as MuiRadio,
} from "@material-ui/core";
import classNames from "classnames";
import { compose } from "ramda";
import { memo, useState } from "react";
import { UseFormMethods } from "react-hook-form";

import { withError } from "../HOC";
import { Tooltip } from "../Tooltip";
import { CommonFormElProps } from "../types";

import styles from "./Radio.module.scss";
import { RadioDescription } from "./RadioDescription";

type RadioItem = {
  readonly label: string;
  readonly value: string;
  readonly description?: string;
};

export type RadioProps = {
  readonly items: Array<RadioItem>;
  readonly register: UseFormMethods["register"];
  readonly tooltip?: string;
} & CommonFormElProps;

export const Radio = memo<
  RadioProps & Required<Pick<CommonFormElProps, "onChange">>
>(
  ({
    defaultValue = "",
    id,
    items,
    label,
    onChange: onChangeAction,
    register,
    required = false,
    tooltip,
  }) => {
    const [value, setValue] = useState(defaultValue);

    return (
      <FormControl fullWidth component="fieldset">
        <FormLabel
          className={classNames(styles.label)}
          component="legend"
          required={required}
        >
          {label}
          <Tooltip copy={tooltip} />
        </FormLabel>
        <RadioGroup
          row
          name={id}
          value={value}
          onChange={(e, data) => {
            setValue(data);
            onChangeAction(data);
          }}
        >
          {items.map(({ description, label, value }) => {
            const radioDescription = description && (
              <RadioDescription key={description} copy={description} />
            );
            const formLabelClasses = classNames({
              [styles.formLabel]: !!radioDescription,
            });

            return (
              <FormControlLabel
                classes={{ root: formLabelClasses }}
                key={[id, value].join("-")}
                control={<MuiRadio color="secondary" inputRef={register} />}
                label={[label, radioDescription]}
                value={value}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    );
  }
);

export const RadioWithError = compose(withError)(Radio);
